<template>
    <div>
        <!-- https://imagecdn.ymm56.com/ymmfile/static/resource/6379d786-fe5b-429e-a515-a41fb156433e.png -->
        <div id="bottomSetting" v-if="!isC9BSCallCar">
        <div class="bottom-btn l-icon l-icon-setting2" title="个性设置"></div>
        <div class="bottom-btn l-icon l-icon-down" title="下载" v-if="tmscode!=92890 && tmscode!=96325"></div>
        <div class="bottom-btn l-icon l-icon-kucunColor" title="快捷键"></div>
        <div class="bottom-btn l-icon l-icon-kefu" title="客服" v-if="tmscode!=92890" @click="clickCustomer"></div>
        <div class="bottom-btn l-icon l-icon-help" title="帮助" v-if="tmscode!=92890"></div>
        </div>
        <div id="bottomSetting-content" v-else></div>
        <div id="rightSettingBar">
            <div id="rightSettingBar-top-logout" title="关闭">x</div>
            <div class="rightSettingBar-switch" id="rightSettingBar-switch">
                <div class="rightSettingBar-switch-btn l-icon l-icon-setting2 rightSettingBar-switch-btn-current"  title="个性设置"></div>
                <div class="rightSettingBar-switch-btn l-icon l-icon-down" title="下载" v-if="tmscode!=92890 && tmscode!=96325"></div>
                <div class="rightSettingBar-switch-btn l-icon l-icon-kucunColor" title="快捷键"></div>
                <div class="rightSettingBar-switch-btn l-icon l-icon-kefu" title="客服" v-if="tmscode!=92890"></div>
                <div class="rightSettingBar-switch-btn l-icon l-icon-help" title="帮助" v-if="tmscode!=92890"></div>
                <!-- <div class="rightSettingBar-switch-btn l-icon l-icon-settings"></div> -->
            </div>
            <div class="rightSettingBar-content" id="rightSettingBar-content">
                <!-- 个性设置 -->
                <div class="rightSettingBar-item rightSettingBar-item-show">
                    <div class="userSetting-outer">
                        <div class="userSetting-title">表格字号设置</div>
                        <div class="userSetting-content gridFontSize-item-outer">
                            <div class="gridFontSize-item">
                                <input class="gridFontSize-input" type="radio" name="changeGridFontSize" value="defaultGrid" checked id="defaultGrid" />
                                <label for="defaultGrid" class="gridFontSize-label">默认</label>
                            </div>
                            <div class="gridFontSize-item">
                                <input class="gridFontSize-input" type="radio" name="changeGridFontSize" value="mediumGrid" id="mediumGrid" />
                                <label for="mediumGrid" class="gridFontSize-label" style="font-size:14px;">中号</label>
                            </div>
                            <div class="gridFontSize-item">
                                <input class="gridFontSize-input" type="radio" name="changeGridFontSize" value="bigGrid" id="bigGrid" />
                                <label for="bigGrid" class="gridFontSize-label" style="font-size:16px;">偏大</label>
                            </div>
                            <div class="gridFontSize-item">
                                <input class="gridFontSize-input" type="radio" name="changeGridFontSize" value="largeGrid" id="largeGrid" />
                                <label for="largeGrid" class="gridFontSize-label" style="font-size:18px;">很大</label>
                            </div>
                            <!-- <div class="gridFontSize-item">
                                <input class="gridFontSize-input" type="radio" name="changeGridFontSize" value="hugeGrid" id="hugeGrid" />
                                <label for="hugeGrid" class="gridFontSize-label">巨无霸</label>
                            </div> -->
                        </div>
                    </div>
                    <div class="userSetting-outer">
                        <div class="userSetting-title">表格网格线设置</div>
                        <div class="userSetting-content">
                            <div class="grid-line-part grid-line-part-bz grid-line-current" type="bz">
                                <div class="grid-line-item">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="grid-line-text">标准</div>
                            </div>
                            <div class="grid-line-part grid-line-part-jy" type="jy">
                                <div class="grid-line-item">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="grid-line-text">简约</div>
                            </div>
                        </div>
                    </div>
                    <div class="userSetting-outer">
                        <div class="userSetting-title">表格行高设置</div>
                        <div class="userSetting-content">
                            <div class="grid-lineheight-part grid-lineheight-part-default grid-lineheight-current" type="default">
                                <div class="grid-lineheight-item">
                                    <div class="grid-lineheight-box">
                                        <div></div>
                                    </div>
                                </div>
                                <div class="grid-lineheight-text">单倍</div>
                            </div>
                            <div class="grid-lineheight-part grid-lineheight-part-height" type="height">
                                <div class="grid-lineheight-item">
                                    <div class="grid-lineheight-box grid-lineheight-box-height" >
                                        <div></div>
                                    </div>
                                </div>
                                <div class="grid-lineheight-text">1.5倍</div>
                            </div>
                        </div>
                    </div>

                    <div class="userSetting-outer">
                        <div class="userSetting-title">皮肤设置</div>
                        <div class="userSetting-content" id="skins-content">
                            <!-- <div class="skin-part skin-part-current">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/skins-default.png" />
                                <div class="skin-name">默认皮肤</div>
                            </div> -->
                        </div>
                    </div>
                    <div class="userSetting-outer">
                        <div class="userSetting-title">数据看板</div>
                        <div class="userSetting-content zhuyeStyle-outer" style="padding:0px 3px">
                            <div class="gridFontSize-item" style="width:50%;">
                                <input class="gridFontSize-input" type="radio" name="zhuyeStyle" checked id="zhuyeStyle-kx" value="kx" />
                                <label for="zhuyeStyle-kx" class="gridFontSize-label" style="padding-left: 28px;">全面指标</label>
                            </div>
                            <div class="gridFontSize-item">
                                <input class="gridFontSize-input" type="radio" name="zhuyeStyle" id="zhuyeStyle-jj" value="jj" />
                                <label for="zhuyeStyle-jj" class="gridFontSize-label" style="padding-left: 28px;">精简指标</label>
                            </div>
                        </div>
                    </div>
                    <div class="userSetting-outer">
                        <div style="display: flex;align-items: center;justify-content: space-between;">
                            <div class="userSetting-title">局域网打印</div>
                            <div class="default-checkbox" style="display: none;">
                                <input type="checkbox" id="defaultPrint" style="vertical-align: middle;" />
                                <label>默认打开</label>
                            </div>
                            
                        </div>
                        <div class="userSetting-content">
                            <div class="toggle" id="showHideToggle">
                                <input type="checkbox" class="check" name="showHideToggle" id="showHideToggle-input">
                                <b class="b switch"></b>
                                <b class="b track"></b>
                                <span class="toggle-txt toggle-txt-close">关</span>
                                <span class="toggle-txt toggle-txt-open">开</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 二维码下载 -->
                <div class="rightSettingBar-item" v-if="tmscode!=92890 && tmscode!=96325">
                    <div class="app-down-ewm-new">
                        <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-lq-code.png?v=1" alt="">
                        <!-- <p>蓝桥标准版</p> -->
                    </div>
                    <div class="app-down-ewm-new">
                        <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-home-code.png?v=1" alt="">
                        <!-- <p>蓝桥家装版</p> -->
                    </div>
                    <div class="app-down-ewm-new">
                        <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-wb-code.png?v=1" alt="">
                        <!-- <p>微步配送</p> -->
                    </div>
                </div>
                <!-- 全局快捷键 -->
                <div class="rightSettingBar-item">
                    <div class="shortcut-key-body">
                        <div class="creat-desktop-title">创建桌面快捷入口</div>
                        <div class="big-menu hasGoods desktop" @click="createLinkInTen">
                            <a class="l-link-item l-link" data-text="点击创建桌面窗口">
                                <img class="menu-icon l-icon-desktop" src="https://imagecdn.ymm56.com/ymmfile/static/resource/513c995f-b840-4be2-bebd-8d302f090958.png"/>
                                <span>创建桌面入口</span>
                            </a>
                        </div>
                        <div class="title">全局操作快捷键</div>
                        <div class="content">
                            <ul>
                                <li><div>动作</div><div>快捷键</div></li>
                                <li><div>新增</div><div>Ctrl+F1</div></li>
                                <li><div>修改</div><div>Ctrl+F2</div></li>
                                <li><div>保存</div><div>F4</div></li>
                                <li><div>删除</div><div>F6</div></li>
                                <li><div>保存并打印</div><div>F9</div></li>
                                <li><div>退出</div><div>Esc</div></li>
                                <li><div>提取</div><div>Ctrl+空格键</div></li>
                                <li><div>导出</div><div>Ctrl+D</div></li>
                                <li><div>表格设置</div><div>Ctrl+S</div></li>
                                <li><div>锁定外观</div><div>Ctrl+L</div></li>
                                <li><div>快找</div><div>Ctrl+F</div></li>
                                <li><div>选中文字</div><div>Ctrl+A</div></li>
                                <li><div>剪切复制</div><div>Ctrl+X</div></li>
                                <li><div>复制</div><div>Ctrl+C</div></li>
                                <li><div>黏贴</div><div>Ctrl+V</div></li>
                                <li><div>浏览器恢复100%</div><div>Ctrl+0(零)</div></li>
                                <li><div>快速开单</div><div>Ctrl+1(一)</div></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- 客户服务 -->
                <div class="rightSettingBar-item" v-if="tmscode!=92890">
                    <div v-if="clientService">
                        <div @click="openWx" class="kefu-item" id="openWx">
                            <i class="l-icon l-icon-weixin"></i>
                            <div class="kefu-item-title">{{clientService.title}}</div>
                            <div class="kefu-item-content">{{clientService.content}}</div>
                        </div>
                    </div>
                    <div class="kefu-item">
                        <i class="l-icon l-icon-toubao"></i>
                        <div class="kefu-item-title">保险咨询热线(微信同号)</div>
                        <div class="kefu-item-content">赵总/13430245392</div>
                    </div>
                    <div class="kefu-item">
                        <i class="l-icon l-icon-user"></i>
                        <div class="kefu-item-title">服务顾问</div>
                        <div id="click-server-bar" class="kefu-item-content">{{ CookiesNewsReaders }}</div>
                    </div>
                    <div @click="openComplaint" class="kefu-item" style="padding-top: 20px; padding-bottom: 20px;">
                        <i class="l-icon">
                        <img class="complaint-icon" src="https://imagecdn.ymm56.com/ymmfile/static/image/complaint.png" />
                        </i>
                        <div class="complaint-item-title">服务投诉</div>
                        <!-- <div id="click-server-bar" class="kefu-item-content">{{ CookiesNewsReaders }}</div> -->
                    </div>
                </div>
                <!-- 帮助 -->
                <div class="rightSettingBar-item" v-if="tmscode!=92890">
                    <ul class="help-outer">
                        <li>
                            <a class="l-link-item" data-tabid="1302" data-text="公司公告" :data-url="Notice">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-notice.png" />
                                <span>公司公告</span>
                            </a>
                        </li>
                        <li>
                            <a class="l-link-item" data-tabid="workOrderCenter" data-text="工单中心" :data-url="workOrderCenter">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-update.png" style="width:22px;height:22px;"  />
                                <span>工单中心</span>
                            </a>
                        </li>
                        <li>
                            <a class="l-link-item" data-tabid="updateRecord" data-text="更新记录" :data-url="updateRecords">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-update.png" style="width:22px;height:22px;" />
                                <span>更新记录</span>
                            </a>
                        </li>
                        <li>
                            <a class="l-link-item" data-tabid="zyDownload" data-text="资源大本营" :data-url="resourceBase">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-update.png" style="width:22px;height:22px;" />
                                <span>资源大本营</span>
                            </a>
                        </li>
                        <li>
                            <a class="l-link-item" data-tabid="ProblemsLibrary" data-text="常见问题" :data-url="commonProblems">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-wt.png" />
                                <span>常见问题</span>
                            </a>
                        </li>
                        <li>
                            <a class="l-link-item" data-tabid="TextCourse" data-text="图文教程" :data-url="pictureTextTutorial">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-wt.png" />
                                <span>图文教程</span>
                            </a>
                        </li>
                        <li onclick="openPrintWin()">
                            <a class="l-link-item">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-wt.png" />
                                <span style="text-decoration:none !important;">打印故障排查</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="rightSettingBar-bottom">
                <div id="rightSettingBar-bottom-logout">关闭</div>
            </div>
        </div>
        <ServiceComplaint ref="serviceComplaintRef" />
    </div>
</template>

<script>
import { includeScript } from '@/utils/common'
import { createDialog } from '@meta-vue/create-dialog'
import ServicerDialog from '@/views/srvicerDialog/index.vue'
import { SCRIPT_BASEURL } from '@/utils/enum'
import ServiceComplaint from './ServiceComplaint'
// import { getEVNUrlByWhitelist } from '@/utils/common'
export default {
  name: 'BottomSetting',
  components: {
    ServiceComplaint
  },
  data () {
    return {
        CookiesNewsReaders: $.cookie('tmsbsnewsreaders'),
        Notice: '/Notice/Index',
        workOrderCenter: '/WorkOrderCenter/Index',
        updateRecords: "/updateRecord/Index",
        resourceBase: '/zyDownload/Index',
        commonProblems: '/zyDownload/ProblemsLibrary',
        pictureTextTutorial: '/zyDownload/TextCourse',
        tmscode: Number($.getcookie('tmsbstmscode')),
        clientService: JSON.parse(localStorage.getItem('configMap') || '{}') &&  JSON.parse(localStorage.getItem('configMap') || '{}').clienteleService,
        isCustomerMenuShow: false,
        isSanbaoShow: !sessionStorage.getItem('proxyOperateKey'),
        currentTime: 0,
        isC9BSCallCar: $.getcookie('TMSversion') === window.LQAPI.C9BS_CALL_CAR
    }
  },
  mounted () {
    window.bottom_setting_vm = this
    this.Notice= getEVNUrlByWhitelist('/Notice/Index')
    this.workOrderCenter= getEVNUrlByWhitelist('/WorkOrderCenter/Index')
    this.updateRecords= getEVNUrlByWhitelist('/updateRecord/Index')
    this.resourceBase= getEVNUrlByWhitelist('/zyDownload/Index')
    this.commonProblems= getEVNUrlByWhitelist('/zyDownload/ProblemsLibrary')
    this.pictureTextTutorial= getEVNUrlByWhitelist('/zyDownload/TextCourse')
    includeScript([
      SCRIPT_BASEURL + '/shared/bottomSetting.js'
    ])
  },
  methods: {
    openServicerDialog() {
        const [name, phone] = this.CookiesNewsReaders&&this.CookiesNewsReaders.split('/');
        const vm = createDialog(
            ServicerDialog,
            {
                name: name,
                phone: phone,
                onClose: () => {
                    vm.hide()
                }
            },
            {
                title: '服务顾问 - 企业ID：' + getCookie("tmscode") ,
                width: '480px',
                'close-on-click-modal': false
            }
        )
        vm.show()
    },
    createLinkInTen () {
         window.lib && window.lib.track.tap('create_desktopEnter', 'Main', {
            pageName: 'lanqiao_saas_home'
        })
        if (!this.currentTime) {
            this.currentTime = new Date().getTime()
            this.createDeskLink()
        }
        if (new Date().getTime() - this.currentTime > 10000) {
            this.currentTime = 0
        }
    },
    
    createDeskLink() {
    // 生成链接和标题的基本设置
        let linkHref1 = "https://t9bs.lqfast.com/lq-saas-web/home/index";
        if ($.cookie("HOMEPAGE_VERSION") == "V2") {
            linkHref1 = "https://t9bs.lqfast.com/lq-saas-web/homeV2/index";
        }
        const linkTitle1 = "蓝桥SaaS";
        let linkHref2 = '';
        let linkTitle2 = '';
            // 创建并下载链接的函数
            const createAndDownloadLink = (href, title) => {
                const escapedHref = href.replace(/"/g, '\\"'); 
                const htmlContent = `
                    <!DOCTYPE html>
                        <html lang="en">
                        <head>
                            <meta charset="UTF-8">
                            <title>${title}</title>
                        </head>
                        <body>
                            <script>
                                window.location.replace('${href}');
                            <\/script>
                        </body>
                    </html>
                `;

                // 创建一个 Blob 对象，内容为 HTML 文件内容
                const blob = new Blob([htmlContent], { type: 'text/html' });

                // 创建一个链接元素
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${title}.html`;
                // 触发下载
                link.click();
            };

            // 下载第一个链接
            createAndDownloadLink(linkHref1, linkTitle1);

            // 如果有第二个链接，下载第二个链接
            if (linkHref2) {
                createAndDownloadLink(linkHref2, linkTitle2);
            }

            // 更新图标
            const iconUrl = 'https://imagecdn.ymm56.com/ymmfile/static/resource/a046a19c-86ad-4b55-ac00-cd491d85062e.png'; 
            $('#hideInsurePopConfirmImg').attr('src', iconUrl);

            // 打开提示框
            $.ligerDialog.open({
                title: "提示",
                target: $("#hideInsurePopConfirm"),
                width: 800,
                height: 720,
            });
    },

     
    openWx () {
        var wxDialogTitle = JSON.parse(localStorage.getItem('configMap') || '{}') &&  JSON.parse(localStorage.getItem('configMap') || '{}').quickClienteleService
        $.ligerDialog.open({
            title: wxDialogTitle.title,
            modal: false,
            width: 514,
            height: 517,
            url: '/weCom/weCom',
            name: 'weCom'
        });
        window.lib && window.lib.track.tap('enter_WChat2', 'Bar', {
            pageName: 'lanqiao_saas_home'
        })
    },
    clickCustomer () {
        if (!this.isCustomerMenuShow && window.lib && window.lib.track) {
            window.lib.track.view('enter_WChat2', 'Bar', {
                pageName: 'lanqiao_saas_home',
            })
            // 服务投诉埋点曝光
            window.lib.track.view('enter_complaint', 'Main', {
                pageName: 'lanqiao_saas_home',
            })
        }
        this.isCustomerMenuShow = !this.isCustomerMenuShow
    },
    // 打开服务投诉弹窗
    openComplaint() {
        this.$refs.serviceComplaintRef.show()
        // 服务投诉埋点点击
        window.lib && window.lib.track.tap('enter_complaint', 'Main', {
            pageName: 'lanqiao_saas_home',
        })
        // 投诉发送按钮曝光
        window.lib && window.lib.track.view('send_complaint', 'Main', {
            pageName: 'lanqiao_saas_home',
        })
    }
  },
  beforeDestroy () {
   delete window.bottom_setting_vm 
  }
}
</script>

<style >
    #bottomSetting-content {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 170px;
        height: 30px;
        z-index: 1002;
        background: #3e5667;
    }
    .creat-desktop-title{
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        color: #F2F3F4;
        margin-bottom: 6px;
    }
    #bottomSetting {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 170px;
        height: 30px;
        z-index: 1002;
        background: #103e67;
    }
    
    .bottom-btn {
        /*width: 16.666%;*/
        width: 20%;
        height: 100%;
        line-height: 30px;
        float: left;
        text-align: center;
        background: none;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
    }

        .bottom-btn:hover {
            background: #1f4e78;
        }

    #bottomSetting.miniBottomSetting {
        width: 45px;
        /*height: 180px;*/
        height: 150px;
    }

    .miniBottomSetting .bottom-btn {
        width: 100%;
        height: 30px;
    }
    #bottomSetting.diffBottomSetting{
        bottom: 36px;
    }
    #rightSettingBar {
        position: fixed;
        left: -160px;
        top: 71px;
        width: 250px;
        height: 100%;
        z-index: 1000;
        background: #d3d6da;
        padding-top: 44px;
        padding-bottom: 110px;
        color: #0f263a;
        display: none;
        box-sizing: border-box;
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -ms-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        transition: all 0.5s ease;
        box-shadow: 5px 4px 10px 0px rgba(0,0,0,0.5);
    }

        #rightSettingBar.miniLeft {
            left: 45px;
        }

        #rightSettingBar.bigLeft {
            left: 160px;
        }
    #rightSettingBar.diffheight{
        padding-bottom: 150px;
    }
    #rightSettingBar.diffheight #rightSettingBar-bottom{
        bottom: 107px;
    }
    .rightSettingBar-switch {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 44px;
        z-index: 1000;
        background: #1f4e78;
    }

    .rightSettingBar-switch-btn {
        /*width: 13.5%;*/
        width: 16%;
        height: 100%;
        line-height: 44px;
        float: left;
        text-align: center;
        background: none;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
    }

        .rightSettingBar-switch-btn:hover {
            background: #3e5667;
        }

    .rightSettingBar-switch-btn-current {
        background: #3e5667;
    }

    .rightSettingBar-content {
        overflow-y: auto;
        height: 100%;
    }

    .rightSettingBar-item {
        display: none;
        height: 100%;
        padding: 5px;
        box-sizing: border-box;
    }

    .rightSettingBar-item-show {
        display: block;
    }

    #rightSettingBar-bottom {
        position: absolute;
        left: 0;
        bottom: 70px;
        height: 30px;
        width: 100%;
        background: #2f4554;
        /*border-top:1px dashed #fff;*/
    }

    #rightSettingBar-bottom-logout {
        position: relative;
        /*left: 50%;*/
        /*top: 50%;*/
        width: 100%;
        height: 30px;
        text-align: center;
        line-height: 30px;
        /*margin-left: -20px;*/
        /*margin-top: -15px;*/
        background: #103e67;
        font-size: 16px;
        color: #fff;
        /*border-radius: 3px;*/
        cursor: pointer;
    }

        #rightSettingBar-bottom-logout:hover {
            opacity: 0.8;
        }

    .app-down-ewm-new {
        /*width: 116px;
        height: 130px;*/
        width: 150px;
        height: 180px;
        margin: 0px auto 10px;
        padding: 5px;
        text-align: center;
        color: #000;
        font-size: 12px;
        border-radius: 3px;
        background-color: #fff;
        overflow: hidden;
        box-sizing: border-box;
    }

    .app-down-ewm-new img {
        width: 100%;
    }

    .shortcut-key-body .title {
        font-size: 14px;
        color: #fff;
        line-height: 22px;
        margin-bottom: 12px;
        margin-top:6px;
    }

    .shortcut-key-body .content {
        border: 1px solid #eee;
        border-bottom: 0 none;
    }

        .shortcut-key-body .content li {
            line-height: 30px;
            border-bottom: 1px solid #eee;
            overflow: hidden;
        }

            .shortcut-key-body .content li:first-child {
                background: #3e5667;
            }

                .shortcut-key-body .content li:first-child div {
                    color: #fff;
                }

            .shortcut-key-body .content li div {
                float: left;
                text-indent: 10px;
                color: #1f4e78;
            }

                .shortcut-key-body .content li div:first-child {
                    width: 100%;
                }

                .shortcut-key-body .content li div:last-child {
                    width: 80px;
                    margin-left: -80px;
                    border-left: 1px solid #eee;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                }

    .kefu-item {
        border: 1px solid #dae3f2;
        width: 96%;
        margin: 0 auto;
        box-sizing: border-box;
        padding-left: 60px;
        padding-top: 8px;
        padding-bottom: 8px;
        line-height: 20px;
        font-size: 12px;
        position: relative;
        cursor: pointer;
        margin-bottom: 10px;
    }

        .kefu-item:hover {
            border-color: #03a9f4;
            color: #03a9f4;
        }

        .kefu-item .l-icon {
            position: absolute;
            left: 14px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 30px;
            width: 30px;
            height: 30px;
            color:#fff;
        }

    .help-outer li {
        height: 30px;
        line-height: 30px;
        margin-bottom: 10px;
    }

        .help-outer li img {
            vertical-align: middle;
            width: 24px;
            height: 24px;
            margin-right: 10px;
        }

        .help-outer li span {
            vertical-align: middle;
            font-size: 14px;
        }

    .userSetting-outer {
        padding:5px;
        border-radius: 5px;
        margin-bottom: 5px;
        background: #bfc6d2;
    }
    /*.userSetting-outer + .userSetting-outer{
        border-top:1px dashed #fff;
    }*/
    .userSetting-title {
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        /*text-indent: 16px;*/
        position: relative;
        color:#0f263a;
        text-indent: 5px;
    }

        /*.userSetting-title::after {
            content: '';
            position: absolute;
            left: 0;
            top: 11px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #ffc545;
        }*/

    .userSetting-content {
        overflow: hidden;
    }

    .gridFontSize-item {
        float: left;
        /*width: 25%;*/
        line-height: 30px;
        position: relative;
    }
    .gridFontSize-item + .gridFontSize-item{
        margin-left: 3px;
    }

    .gridFontSize-input {
        vertical-align: middle;
        cursor: pointer;
        position: absolute;
        opacity:0;
    }
    
    .gridFontSize-label {
        vertical-align: middle;
        cursor: pointer;
        position: relative;
        padding-left: 20px;
    }
    .gridFontSize-label:before {
        content: '';
        width: 20px;
        height: 20px;
        background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/skins-btn_xz_o.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 16px 16px;
        display: inline-block;
        position: absolute;
        top: 50%;
        left:0px;
        margin-top: -10px;
    }

    .gridFontSize-input:checked ~ .gridFontSize-label:before {
        background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/skins-btn_xz_o_p.png);
    }
    .gridFontSize-input:checked ~ .gridFontSize-label {
        color: #03a9f4;
    }

    .skin-part {
        float: left;
        width: 45%;
        margin: 0 2.5% 10px;
        cursor: pointer;
    }

        .skin-part img {
            width: 100%;
            box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.5);
        }

    .skin-name {
        line-height: 24px;
        background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/skins-btn_xz_o.png);
        background-repeat: no-repeat;
        background-position: center left;
        background-size: 16px 16px;
        text-indent: 28px;
        margin-top: 5px;
    }

    .skin-part-current .skin-name {
        background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/skins-btn_xz_o_p.png);
    }

    .rightSettingBar-item .l-link-item:hover {
        color: #03a9f4;
    }

    .rightSettingBar-item .l-link-item.activeColor {
        color: #03a9f4 !important;
    }

        .rightSettingBar-item .l-link-item.activeColor span {
            color: #03a9f4 !important;
        }

    #rightSettingBar-top-logout {
        position: absolute;
        right: 0;
        top: 0;
        width: 44px;
        height: 44px;
        line-height: 38px;
        text-align: center;
        font-size: 26px;
        z-index: 9000;
        cursor: pointer;
        /*border: 4px solid #4e616f;*/
        box-sizing: border-box;
    }

        #rightSettingBar-top-logout:hover {
            color: red;
            background: #2f4554;
        }
    .grid-line-text {
        line-height: 24px;
        background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/skins-btn_xz_o.png);
        background-repeat: no-repeat;
        background-position: center left;
        background-size: 16px 16px;
        text-indent: 28px;
        margin-top: 5px;
    }

    .grid-line-current .grid-line-text {
        background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/skins-btn_xz_o_p.png);
    }
    .grid-line-part{
        float: left;
        width: 45%;
        margin:0 2.5%;
        box-sizing: border-box;
        cursor: pointer;
    }
    .grid-line-item{
        border: 2px solid #000;
        height: 60px;
        display:flex;
        background: #c3d7ea;
    }
    .grid-line-item div{
        flex:1;
        position: relative;
    }
    .grid-line-item div + div{
        border-left: 2px solid #000;
    }
    .grid-line-part-bz .grid-line-item div:before{
        content:"";
        width: 100%;
        height: 2px;
        background:#000;
        position: absolute;
        left:0;
        top:33.33%;
    }
    .grid-line-part-bz .grid-line-item div:after{
        content:"";
        width: 100%;
        height: 2px;
        background:#000;
        position: absolute;
        left:0;
        top:66.66%;
    }

    #showHideToggle .b {
        display: block;
    }

    #showHideToggle.toggle {
        position: relative;
        width: 40px;
        height: 20px;
        border-radius: 100px;
        background-color: #ddd;
        box-shadow: inset 0 0 2px 1px rgba(0,0,0,.05);
        margin:0 auto;
    }

    #showHideToggle .check {
        position: absolute;
        display: block;
        cursor: pointer;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 6;
    }

    #showHideToggle .check:checked ~ .track {
        box-shadow: inset 0 0 0 20px #4bd863;
    }

    #showHideToggle.error .check:checked ~ .track {
        box-shadow: inset 0 0 0 20px #FF9800;
    }

    #showHideToggle .check:checked ~ .switch {
        right: 2px;
        left: 22px;
        transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);
        transition-property: left, right;
        transition-delay: .05s, 0s;
    }

    #showHideToggle .check:checked ~ .toggle-txt-open {
        display: block;
    }

    #showHideToggle .check:checked ~ .toggle-txt-close {
        display: none;
    }

    #showHideToggle .switch {
        position: absolute;
        left: 2px;
        top: 2px;
        bottom: 2px;
        right: 22px;
        background-color: #fff;
        border-radius: 36px;
        z-index: 1;
        transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);
        transition-property: left, right;
        transition-delay: 0s, .05s;
        box-shadow: 0 1px 2px rgba(0,0,0,.2);
    }

    #showHideToggle .track {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);
        box-shadow: inset 0 0 0 2px rgba(0,0,0,.05);
        border-radius: 40px;
    }
    
    .grid-lineheight-text {
        line-height: 24px;
        background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/skins-btn_xz_o.png);
        background-repeat: no-repeat;
        background-position: center left;
        background-size: 16px 16px;
        text-indent: 28px;
        margin-top: 5px;
    }

    .grid-lineheight-current .grid-lineheight-text {
        background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/skins-btn_xz_o_p.png);
    }
    .grid-lineheight-part{
        float: left;
        width: 45%;
        margin:0 2.5%;
        box-sizing: border-box;
        cursor: pointer;
    }
    .grid-lineheight-item{
        height: 40px;
        position: relative;
    }
    .grid-lineheight-box {
        height: 24px;
        width: 100%;
        border-top: 2px solid #4d78c9;
        border-bottom: 2px solid #4d78c9;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    .grid-lineheight-box div {
        width: 2px;
        height: 80%;
        background: #4d78c9;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .grid-lineheight-box div:before {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0px 4px 4px 4px;
        border-color: transparent transparent #4d78c9 transparent;
        position: absolute;
        left: -3px;
        top: 0;
    }
    .grid-lineheight-box div:after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width:  4px 4px 0px 4px;
        border-color:#4d78c9 transparent transparent transparent;
        position: absolute;
        left: -3px;
        bottom: 0;
    }
    .grid-lineheight-box-height{
        height: 34px;
    }
</style>
